<template>
    <div class="m-2 p-4">
        <div class="flex flex-col lg:flex-row">
            <text-input v-if="order.phone" v-model="order.phone" class="pb-8 w-full lg:w-1/2"
                        label="Телефон"/>
            <text-input v-model="order.totalSum" class="pb-8 lg:ml-6 w-full lg:w-1/2"
                        label="Сума"/>
        </div>
        <div class="flex flex-col lg:flex-row">
            <text-input v-model="order.point.name" class="pb-8 w-full lg:w-1/2"
                    label="Місце"/>
            <text-input v-model="order.lake.name" class="pb-8 lg:ml-6 w-full lg:w-1/2"
                    label="Озеро"/>
        </div>
        <div class="flex flex-col lg:flex-row">
            <text-input v-model="order.type.name" class="pb-8 w-full lg:w-1/2"
                    label="Тип рибалки"/>
            <text-input v-if="order.category" v-model="order.category.name" class="pb-8 lg:ml-6 w-full lg:w-1/2"
                    label="Тариф рибалки"/>
        </div>
        <div class="flex flex-col lg:flex-row">
            <text-input v-model="order.quantity" class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Кількість людей"/>
            <select-input
                v-model="attributesIds"
                class="pb-8 w-full lg:w-1/2"
                label="Атрибути"
                multiple
            >
                <option
                    v-for="attribute in order.attributes"
                    :key="attribute.id"
                    :value="attribute.id"
                >
                    {{ attribute.title }}
                </option>
            </select-input>
        </div>


        <div class="flex">
            <checkbox
                v-model="order.is_payed"
                disabled
                class="mr-8"
                label="Оплачено"
            />
            <checkbox
                :model-value="order.is_done"
                class="mr-8"
                label="Виконано"
                @update:modelValue="value => approveOrder(value, order)"
            />
            <checkbox
                v-model="order.is_cancel"
                label="Скасовано"
                @update:modelValue="value => canceled(value, order)"
            />
        </div>
    </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import Checkbox from '@/Shared/Checkbox'
import SelectInput from "@/Shared/SelectInput.vue";

export default {
    name: "OrderDetail",
    components: {
        SelectInput,
        Checkbox,
        TextInput,
    },
    props: {
        order: {
            type: Object,
            require: true
        },
    },
    data() {
        return {
            attributesIds: this.order.attributes.map(attribute => {
                return attribute.id
            })
        }
    },
    methods: {
        download() {
            this.$inertia.get(this.$route('invoice.download', this.order.liqPayId))
        },
        approveOrder(value, order) {
            this.$inertia.post(
                this.$route('order.approve', order.id),
                {
                    is_done: value
                },
                {
                    preserveState: true,
                    preserveScroll: true
                }
            );
        },
        canceled(value, order) {
            this.$inertia.post(this.$route('order.cancel', order.id),
                {
                    is_cancel: value
                },
                {
                    preserveState: true,
                    preserveScroll: true
                }
            );
        },
    }
}
</script>
